import { render } from "./customButton.vue?vue&type=template&id=49bacf31"
const script = {}

import "./customButton.vue?vue&type=style&index=0&id=49bacf31&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__